export default __webpack_public_path__ + "images/hlf-no-image_34bbff143df083449878e41b8521d1d0.jpeg";